// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__okylG","imageLink":"Home_imageLink__1wSlj","contentContainer":"Home_contentContainer__RiADX"};